import { SignalDocumentGroup } from "./groupSignals";
import { isSignalUnread } from "./persistentSignalTypes";

export type SignalGroupReadStatus = "unread" | "read" | "partial";

export const signalGroupReadStatus = (group: SignalDocumentGroup): SignalGroupReadStatus => {
  const unreadCount = group.signals.filter(isSignalUnread).length;
  if (unreadCount === 0) return "read";
  if (unreadCount === group.signals.length) return "unread";
  return "partial";
};

export const matchesSignalReadFilter = (
  group: SignalDocumentGroup,
  isUnread: boolean | undefined,
): boolean => {
  if (isUnread === undefined) return true;
  const status = signalGroupReadStatus(group);
  if (isUnread) return status !== "read";
  return status === "read";
};
